import { render, staticRenderFns } from "./PurchaseOrderItems.vue?vue&type=template&id=cf17a05c&"
import script from "./PurchaseOrderItems.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderItems.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderItems.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QSelect,QTr,QTh,QTd,QInput,QIcon,QPopupProxy,QDate,QBtn,QDialog,QCard,QCardSection,QSpace,QSeparator,QCardActions,QItem,QItemSection,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTable,QSelect,QTr,QTh,QTd,QInput,QIcon,QPopupProxy,QDate,QBtn,QDialog,QCard,QCardSection,QSpace,QSeparator,QCardActions,QItem,QItemSection})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
